<template>
  <div id="app">
    <Header />
    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Mehr Freiraum, mehr Lebensqualität</h2>
        <div class="flex justify-center">
          <h1 class="headline">Balkone</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Die erste Tasse Kaffee am Morgen. Ein Platz für die Sonnenliege. Ein ruhiger Moment nach Feierabend. Für viele beginnt oder endet der Tag genau hier: auf dem Balkon. Er ist Rückzugsort, Treffpunkt und Lieblingsplatz. Kurz gesagt: ein Stück gelebte Freiheit direkt am Haus.
        </p>

        <p class="mt-4 text-gray-700">
          Ob freistehend oder ans Gebäude angebunden, ein- oder mehrstöckig, wir planen und fertigen Balkone, die sich perfekt in Ihre Architektur und Lebensgewohnheiten einfügen. Bei der Auswahl des Bodenbelags bieten wir verschiedene Lösungen: wasserdichte Ausführungen mit abgedichteter Wanne und Terrassenplatten, rutschhemmend beschichtete Aluminiumpaneele in verschiedenen Optiken oder sogar begehbare Glasscheiben mit Siebdruck. Wer es offener mag, wählt Holzdielen, WPC-Dielen oder Gitterroste – je nach Stil und Nutzung.
        </p>

        <p class="mt-4 text-gray-700">
          Jede Konstruktion ist robust, langlebig und wetterfest, feuerverzinkt oder zusätzlich pulverbeschichtet. Kombiniert mit einem passenden Balkongeländer aus unserer Fertigung entsteht so ein Außenbereich, der nicht nur praktisch ist, sondern echte Lebensqualität schafft.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Balkone" pixelEvent="FormBalkoneSent" />
      <CallToAction />
    </Page>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    ProduktKontaktformular,
    PhotoGallery,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/balkone/1.jpg", alt: "Balkon 1" },
        { src: "img/produkte/balkone/2.jpg", alt: "Balkon 2" },
        { src: "img/produkte/balkone/3.jpg", alt: "Balkon 3" },
        { src: "img/produkte/balkone/4.jpg", alt: "Balkon 4" },
        { src: "img/produkte/balkone/5.jpg", alt: "Balkon 5" },
        { src: "img/produkte/balkone/6.jpg", alt: "Balkon 6" },
        { src: "img/produkte/balkone/7.jpg", alt: "Balkon 7" },
        { src: "img/produkte/balkone/8.jpg", alt: "Balkon 8" },
        { src: "img/produkte/balkone/9.jpg", alt: "Balkon 9" },
        { src: "img/produkte/balkone/10.jpg", alt: "Balkon 10" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
